import React, { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import { parentUser, staffUser } from '../../../lib/services/auth.service';
import { SessionType } from '../../../lib/types/session.types';
import { staffPostLoginPath } from '../../../lib/helpers/next-path.helpers';
import { parentPostLoginPath } from '../../../lib/helpers/parent-links.helpers';
import { useIntlSnackbar } from '../../../lib/hooks/use-intl-snackbar';
import { messages } from './signed-in-redirect.messages';

interface ISignedInRedirect {
  tree: SessionType;
  // The URL carries a one-time link (a login or reset token) that redirecting drops, so the user is warned.
  discardsLink?: boolean;
}

// Skips an auth page for someone already signed in to that app. See "Auth pages skip themselves
// for someone already signed in to that app" in CLAUDE.md.
export const SignedInRedirect: React.FC<ISignedInRedirect> = ({ tree, discardsLink = false, children }) => {
  const { search } = useLocation();
  const showSnackbar = useIntlSnackbar();
  const [signedInOnArrival] = useState(() => Boolean(tree === SessionType.PARENT ? parentUser() : staffUser()));

  useEffect(() => {
    if (signedInOnArrival && discardsLink) showSnackbar(messages.signOutToUseLink, 'warning');
    // Decided once, on arrival, like the redirect itself.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (signedInOnArrival) {
    return <Redirect to={tree === SessionType.PARENT ? parentPostLoginPath(search) : staffPostLoginPath(search)} />;
  }

  return <>{children}</>;
};
